"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStarOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.66 11.24l-10.35-1.17L16 .58l-4.31 9.49-10.35 1.17 7.69 7-2.09 10.23L16 23.33l9.06 5.14L23 18.27zM16 21l-6.22 3.56 1.43-7-5.28-4.83 7.11-.8 3-6.51 3 6.51 7.11.8-5.28 4.83 1.43 7z" })));
}
exports.default = SvgStarOutline;
//# sourceMappingURL=StarOutline.js.map